var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Google@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8139535,6.54545455 L8.18604651,6.54545455 L8.18604651,9.63636364 L12.5767442,9.63636364 C12.1674419,11.6 10.455814,12.7272727 8.18604651,12.7272727 C5.50697674,12.7272727 3.34883721,10.6181818 3.34883721,8 C3.34883721,5.38181818 5.50697674,3.27272727 8.18604651,3.27272727 C9.33953488,3.27272727 10.3813953,3.67272727 11.2,4.32727273 L13.5813953,2 C12.1302326,0.763636364 10.2697674,0 8.18604651,0 C3.64651163,0 0,3.56363636 0,8 C0,12.4363636 3.64651163,16 8.18604651,16 C12.2790698,16 16,13.0909091 16,8 C16,7.52727273 15.9255814,7.01818182 15.8139535,6.54545455 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8139535,6.54545455 L8.18604651,6.54545455 L8.18604651,9.63636364 L12.5767442,9.63636364 C12.1674419,11.6 10.455814,12.7272727 8.18604651,12.7272727 C5.50697674,12.7272727 3.34883721,10.6181818 3.34883721,8 C3.34883721,5.38181818 5.50697674,3.27272727 8.18604651,3.27272727 C9.33953488,3.27272727 10.3813953,3.67272727 11.2,4.32727273 L13.5813953,2 C12.1302326,0.763636364 10.2697674,0 8.18604651,0 C3.64651163,0 0,3.56363636 0,8 C0,12.4363636 3.64651163,16 8.18604651,16 C12.2790698,16 16,13.0909091 16,8 C16,7.52727273 15.9255814,7.01818182 15.8139535,6.54545455 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8139535,6.54545455 L8.18604651,6.54545455 L8.18604651,9.63636364 L12.5767442,9.63636364 C12.1674419,11.6 10.455814,12.7272727 8.18604651,12.7272727 C5.50697674,12.7272727 3.34883721,10.6181818 3.34883721,8 C3.34883721,5.38181818 5.50697674,3.27272727 8.18604651,3.27272727 C9.33953488,3.27272727 10.3813953,3.67272727 11.2,4.32727273 L13.5813953,2 C12.1302326,0.763636364 10.2697674,0 8.18604651,0 C3.64651163,0 0,3.56363636 0,8 C0,12.4363636 3.64651163,16 8.18604651,16 C12.2790698,16 16,13.0909091 16,8 C16,7.52727273 15.9255814,7.01818182 15.8139535,6.54545455 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8139535,6.54545455 L8.18604651,6.54545455 L8.18604651,9.63636364 L12.5767442,9.63636364 C12.1674419,11.6 10.455814,12.7272727 8.18604651,12.7272727 C5.50697674,12.7272727 3.34883721,10.6181818 3.34883721,8 C3.34883721,5.38181818 5.50697674,3.27272727 8.18604651,3.27272727 C9.33953488,3.27272727 10.3813953,3.67272727 11.2,4.32727273 L13.5813953,2 C12.1302326,0.763636364 10.2697674,0 8.18604651,0 C3.64651163,0 0,3.56363636 0,8 C0,12.4363636 3.64651163,16 8.18604651,16 C12.2790698,16 16,13.0909091 16,8 C16,7.52727273 15.9255814,7.01818182 15.8139535,6.54545455 Z",
    id: "path-9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Google"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F4FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.488037, 8.999512)",
    id: 1534129544
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FBBC05",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    points: "-0.744186047 12.7272727 -0.744186047 3.27272727 5.58139535 8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EA4335",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    points: "-0.744186047 3.27272727 5.58139535 8 8.18604651 5.78181818 17.1162791 4.36363636 17.1162791 -0.727272727 -0.744186047 -0.727272727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#34A853",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    points: "-0.744186047 12.7272727 10.4186047 4.36363636 13.3581395 4.72727273 17.1162791 -0.727272727 17.1162791 16.7272727 -0.744186047 16.7272727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4285F4",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    points: "17.1162791 16.7272727 5.58139535 8 4.09302326 6.90909091 17.1162791 3.27272727"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeGoogle);
export default __webpack_public_path__ + "static/media/type-google.57b5cdb74d44dbdbeb5b9e47a15db4b9.svg";
export { ForwardRef as ReactComponent };